import styled from 'styled-components';

const TableHead = styled.div`
  display: table-header-group;
  font-weight: bold;
  font-size: 12px;
  color: #888888;
`;

export default TableHead;
